import { render } from "./ScreeningsView.vue?vue&type=template&id=42cb13e4"
const script = {}

import "./ScreeningsView.vue?vue&type=style&index=0&id=42cb13e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__